import type FacilityView from '@UI/Store/Facilities/Views/FacilityView';

/**
 * Resolves a list of facility ids into their names, from the organization's agencies. An id absent
 * from `facilities` (out of the caller's read scope, or not yet loaded) is ignored — never rendered
 * as the raw id standing in for a name.
 */
const resolveFacilityNames = (
	facilityIds: readonly number[],
	facilities: readonly FacilityView[],
): string[] => {
	const facilitiesById = new Map(facilities.map((facility) => [facility.id, facility.name]));

	return facilityIds
		.map((facilityId) => facilitiesById.get(facilityId))
		.filter((name): name is string => name !== undefined);
};

export default resolveFacilityNames;
